import "clsx";
import { F as FAQ } from "../../../../../chunks/FAQ.js";
function _page($$payload) {
  FAQ($$payload);
}
export {
  _page as default
};
